import axios from 'axios'
import { REACT_APP_API } from '../../config'

export async function createOrUpdateDirectByVersion(body) {
    const response = await axios.put(
        `${REACT_APP_API}/bonifications/directa/version`,
        body
    )
    return response?.data?.data
}
